import r2wc from "@r2wc/react-to-web-component";
import { HvsFunnelOverlay } from "./components/hvs-funnel-overlay/hvs-funnel-overlay";

const HvsFunnelOverlayComponent = r2wc(HvsFunnelOverlay, {
  props: {
    randomKey: "string",
    subdomain: "string",
    addressToken: "string",
    callbackUrl: "string",
    type: "string",
    defaultOpen: "boolean",
    toAgentId: "number",
    toTeamId: "number",
    agentBrandedPage: "boolean",
    monthlyValuationAddress: "string",
    monthlyValuationSource: "string",
    percyValuationHigh: "string",
    delay: "number",
  },
});

if (customElements) {
  customElements.define("hvs-funnel-overlay", HvsFunnelOverlayComponent);
}
